import { getStartOfDay, isSameDay } from './dateUtils';

const testDateLogicRule = (userValue, condition) => {
  const {
    op,
    value,
    type,
    intervalUnit,
    intervalCount: intervalCountString
  } = condition;
  const intervalCount = Number(intervalCountString);
  const currentDate = new Date();
  const valueIsAnArray = Array.isArray(value) && value.length === 2;
  const firstArrayObject = valueIsAnArray ? value[0] : null;
  const secondArrayObject = valueIsAnArray ? value[1] : null;
  const firstIntervalCount = firstArrayObject
    ? Number(firstArrayObject.intervalCount)
    : null;
  const secondIntervalCount = secondArrayObject
    ? Number(secondArrayObject.intervalCount)
    : null;
  let testDate = new Date();
  let testDate2 = new Date();
  let normalizedTestDate = getStartOfDay(+testDate);
  let normalizedTestDate2 = getStartOfDay(+testDate2);
  const normalizedUserValue = userValue ? getStartOfDay(+userValue) : userValue;
  const normalizedValue = value ? getStartOfDay(+value) : value;
  const normalizedCurrentDate = currentDate
    ? getStartOfDay(+currentDate)
    : currentDate;

  if (op && value) {
    if (value === 'now' || value === 'NOW()') {
      if (intervalUnit && intervalCount) {
        if (op === '<') {
          // more than in the past
          if (intervalUnit === 'day') {
            testDate.setDate(testDate.getDate() - intervalCount);
          } else if (intervalUnit === 'week') {
            testDate.setDate(testDate.getDate() - intervalCount * 7);
          } else if (intervalUnit === 'month') {
            testDate.setMonth(testDate.getMonth() - intervalCount);
          }
          normalizedTestDate = getStartOfDay(+testDate);
          return userValue && normalizedUserValue < +normalizedTestDate;
        } else if (op === '>') {
          // more than in the future
          if (intervalUnit === 'day') {
            testDate.setDate(testDate.getDate() + intervalCount);
          } else if (intervalUnit === 'week') {
            testDate.setDate(testDate.getDate() + intervalCount * 7);
          } else if (intervalUnit === 'month') {
            testDate.setMonth(testDate.getMonth() + intervalCount);
          }
          normalizedTestDate = getStartOfDay(+testDate);
          return userValue && normalizedUserValue > +normalizedTestDate;
        }
      } else {
        // general in the past or future
        if (op === '<' || op === 'past') {
          return userValue && normalizedUserValue < +normalizedCurrentDate;
        } else if (op === '>' || op === 'future') {
          return userValue && normalizedUserValue > +normalizedCurrentDate;
        }
      }
    } else if (valueIsAnArray) {
      if (
        firstArrayObject.type === 'date' &&
        secondArrayObject.type === 'date'
      ) {
        // between two dates
        return (
          userValue > +firstArrayObject.value &&
          userValue < +secondArrayObject.value
        );
      } else if (firstArrayObject.type === 'date') {
        // less than in the past
        if (secondArrayObject.intervalUnit === 'day') {
          testDate.setDate(testDate.getDate() - secondIntervalCount);
        } else if (secondArrayObject.intervalUnit === 'week') {
          testDate.setDate(testDate.getDate() - secondIntervalCount * 7);
        } else if (secondArrayObject.intervalUnit === 'month') {
          testDate.setMonth(testDate.getMonth() - secondIntervalCount);
        }
        normalizedTestDate = getStartOfDay(+testDate);
        return (
          userValue &&
          normalizedUserValue > +normalizedTestDate &&
          normalizedCurrentDate > normalizedUserValue
        );
      } else if (secondArrayObject.type === 'date') {
        // less than in the future
        if (firstArrayObject.intervalUnit === 'day') {
          testDate.setDate(testDate.getDate() + firstIntervalCount);
        } else if (firstArrayObject.intervalUnit === 'week') {
          testDate.setDate(testDate.getDate() + firstIntervalCount * 7);
        } else if (firstArrayObject.intervalUnit === 'month') {
          testDate.setMonth(testDate.getMonth() + firstIntervalCount);
        }
        normalizedTestDate = getStartOfDay(+testDate);
        return (
          userValue &&
          normalizedUserValue < normalizedTestDate &&
          normalizedCurrentDate < normalizedUserValue
        );
      } else if (
        firstArrayObject.type === 'interval' &&
        secondArrayObject.type === 'interval'
      ) {
        // between two intervals
        if (firstArrayObject.op === 'plus') {
          // more than in the future
          if (firstArrayObject.intervalUnit === 'day') {
            testDate.setDate(testDate.getDate() + firstIntervalCount);
          } else if (firstArrayObject.intervalUnit === 'week') {
            testDate.setDate(testDate.getDate() + firstIntervalCount * 7);
          } else if (firstArrayObject.intervalUnit === 'month') {
            testDate.setMonth(testDate.getMonth() + firstIntervalCount);
          }
          if (secondArrayObject.intervalUnit === 'day') {
            testDate2.setDate(testDate2.getDate() + secondIntervalCount);
          } else if (secondArrayObject.intervalUnit === 'week') {
            testDate2.setDate(testDate2.getDate() + secondIntervalCount * 7);
          } else if (secondArrayObject.intervalUnit === 'month') {
            testDate2.setMonth(testDate2.getMonth() + secondIntervalCount);
          }
          normalizedTestDate = getStartOfDay(+testDate);
          normalizedTestDate2 = getStartOfDay(+testDate2);
          return (
            userValue &&
            ((normalizedUserValue > +normalizedTestDate &&
              normalizedUserValue < +normalizedTestDate2) ||
              (normalizedUserValue < +normalizedTestDate &&
                normalizedUserValue > +normalizedTestDate2))
          );
        } else {
          // more than in the past
          if (firstArrayObject.intervalUnit === 'day') {
            testDate.setDate(testDate.getDate() - firstIntervalCount);
          } else if (firstArrayObject.intervalUnit === 'week') {
            testDate.setDate(testDate.getDate() - firstIntervalCount * 7);
          } else if (firstArrayObject.intervalUnit === 'month') {
            testDate.setMonth(testDate.getMonth() - firstIntervalCount);
          }
          if (secondArrayObject.intervalUnit === 'day') {
            testDate2.setDate(testDate2.getDate() - secondIntervalCount);
          } else if (secondArrayObject.intervalUnit === 'week') {
            testDate2.setDate(testDate2.getDate() - secondIntervalCount * 7);
          } else if (secondArrayObject.intervalUnit === 'month') {
            testDate2.setMonth(testDate2.getMonth() - secondIntervalCount);
          }
          normalizedTestDate = getStartOfDay(+testDate);
          normalizedTestDate2 = getStartOfDay(+testDate2);
          return (
            userValue &&
            ((normalizedUserValue > +normalizedTestDate &&
              normalizedUserValue < +normalizedTestDate2) ||
              (normalizedUserValue < +normalizedTestDate &&
                normalizedUserValue > +normalizedTestDate2))
          );
        }
      }
    } else if (op === '=') {
      return userValue && isSameDay(userValue, value);
    } else if (op === '<') {
      // less than
      return userValue && normalizedUserValue < +normalizedValue;
    } else if (op === '>') {
      // more than
      return userValue && normalizedUserValue > +normalizedValue;
    } else if (op === '<=') {
      // less than
      return userValue && normalizedUserValue <= +normalizedValue;
    } else if (op === '>=') {
      // more than
      return userValue && normalizedUserValue >= +normalizedValue;
    }
  } else if (op === '<>') {
    // not blank
    return !!userValue;
  } else if (
    value === null ||
    value === undefined ||
    value === '' ||
    value === 'blank'
  ) {
    // blank
    return userValue === null || userValue === undefined || userValue === '';
  }
  return false;
};

export default testDateLogicRule;
